module.exports = __webpack_public_path__ + "static/media/user.096c5d73.svg";